import { Chip } from "@mui/material";

type StatusAnuncio =
  | "Em Aberto"
  | "Vendido"
  | "Encerrado"
  | "Inativo";

export const statusChip = (status: StatusAnuncio) => {
  const map: Record<
    StatusAnuncio,
    { label: string; color: string; bg: string }
  > = {
    "Em Aberto": {
      label: "Em aberto",
      color: "#3b82f6", // azul
      bg: "#dbeafe",
    },
    "Inativo": {
      label: "Inativo",
      color: "#f59e0b", // amarelo
      bg: "#fef3c7",
    },
    Vendido: {
      label: "Vendido",
      color: "#22c55e", // verde
      bg: "#dcfce7",
    },
    "Encerrado": {
      label: "Encerrado",
      color: "#ef4444", // vermelho
      bg: "#fee2e2",
    },
  };

  const item = map[status];

  return (
    <Chip
      label={item.label}
      size="small"
      sx={{
        fontSize: "0.7rem",
        fontWeight: 600,
        color: item.color,
        backgroundColor: item.bg,
        borderRadius: "6px",
      }}
    />
  );
};
